import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import SiteSearchAPIConnector from '@elastic/search-ui-site-search-connector';
import { SearchProvider } from '@elastic/react-search-ui';
import queryString from 'query-string';

import { NavItem } from '../../utils/types';
// import './layout.css';
import theme from '../../lib/theme';
import Header from './header';
import Footer from './footer';
import Modal from 'antd/lib/modal/Modal';
import { Button, Col, Input, Row } from 'antd';
import { Content404 } from '../../pages/404';

const NC_ZIP_RANGE = [27006, 28909];
const SC_ZIP_RANGE = [29001, 29948];

const zipRedirect = (zip: string) => {
  window.location.href = `https://zipgate.national.aaa.com?ZipCodeEntry=${zip}`;
};

const parseCookie = (str) =>
  str
    .split(';')
    .map((v) => v.split('='))
    .reduce((acc, v) => {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
      return acc;
    }, {});

export interface LayoutProps {
  navItems?: Array<NavItem>;
  hashLinkItems?: Array<NavItem>;
  children: React.ReactNode;
  onNavItemSelected?: (index: number) => void;
  expandedPage?: boolean;
  tmic?: boolean;
  uic?: boolean;
  footerNoAds?: boolean;
  footerNoNav?: boolean;
  pageNotFound?: boolean;
  hideZip?: boolean;
}

const connector = new SiteSearchAPIConnector({
  documentType: 'page',
  engineKey: '1_FBxtpso2rFJVCYSaoe',
});

const Layout: React.FC<LayoutProps> = ({
  children,
  navItems = [],
  hashLinkItems = [],
  onNavItemSelected = () => undefined,
  expandedPage = false,
  tmic = false,
  uic = false,
  footerNoAds = false,
  footerNoNav = false,
  pageNotFound = false,
  hideZip = false,
}) => {
  const [notInZip, setNotInZip] = React.useState(false);
  const [inDevMode, setInDevMode] = React.useState(false);

  React.useEffect(() => {
    const checkZip = async () => {
      const qs = queryString.parse(window.location.search);
      let zip = Number(qs.zip);

      if (isNaN(zip) || typeof zip !== 'number') {
        const cookies = parseCookie(document.cookie);
        if (cookies.zipcode) {
          zip = Number(cookies.zipcode.split('|')[0]);
        }
      }

      if (isNaN(zip) || typeof zip !== 'number') {
        try {
          const req = await fetch('https://geolocation-db.com/json/');
          const res = await req.json();
          zip = Number(res.postal);
        } catch (err) {
          console.log('fetch err', err);
        }
      }

      if (
        !(
          (zip >= NC_ZIP_RANGE[0] && zip <= NC_ZIP_RANGE[1]) ||
          (zip >= SC_ZIP_RANGE[0] && zip <= SC_ZIP_RANGE[1])
        )
      ) {
        setNotInZip(true);
      }
    };

    if (typeof window !== 'undefined') {
      checkZip();
    }
  }, []);

  React.useEffect(() => {
    const allItems = [...navItems, ...hashLinkItems];
    setTimeout(() => {
      if (typeof window !== 'undefined' && window.location.hash) {
        const idx = allItems
          .map((i) => i.id)
          .indexOf(window.location.hash.slice(1));
        if (idx > -1) {
          history.state;
          history.replaceState(
            history.state,
            'AAA Carolinas',
            `${window.location.origin}${window.location.pathname}`
          );
          onNavItemSelected(idx);
        }
      }
    }, 230);

    if (
      typeof window !== 'undefined' &&
      window.location.origin === 'http://localhost:8000'
    ) {
      setInDevMode(true);
    }
  }, []);

  const handleZipFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    zipRedirect(
      ((e.target as unknown) as Record<string, { value: string }>).zipcode.value
    );
  };

  return (
    <SearchProvider config={{ apiConnector: connector }}>
      <ThemeProvider theme={theme}>
        {!expandedPage ? <Header tmic={tmic} uic={uic} /> : null}
        {/* <Row style={{ padding: 24 }}>
          <Col xs={{ span: 22, offset: 1 }} sm={{ span: 16, offset: 4 }}>
            <strong>
              Due to adverse weather conditions, many AAA offices, Car Care
              Centers and Fins Car Wash locations have closed early on Friday,
              Jan. 21, and may remain closed over the weekend dependent upon
              weather.
            </strong>{' '}
            Please call before visiting any AAA location, and please avoid
            driving in adverse weather conditions. Thank you.
          </Col>
        </Row> */}
        {pageNotFound ? <div>{Content404}</div> : <main>{children}</main>}

        {!expandedPage ? (
          <Footer noAds={footerNoAds} noNav={footerNoNav} />
        ) : null}
        <Modal
          visible={notInZip && !hideZip}
          footer={null}
          closable={inDevMode}
          onCancel={() => setNotInZip(false)}
        >
          <form onSubmit={handleZipFormSubmit}>
            To ensure you receive the best service possible, please enter your
            zip code:
            <Row style={{ marginTop: 16 }} gutter={[16, 16]}>
              <Col xs={{ span: 24 }} sm={{ span: 16 }}>
                <Input name="zipcode" size="large" placeholder="Zip Code" />
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 8 }}>
                <Button
                  type="ghost"
                  style={{ width: '100%' }}
                  size="large"
                  htmlType="submit"
                >
                  Continue
                </Button>
              </Col>
            </Row>
            <p
              style={{
                lineHeight: '1.2',
                color: '#999',
                fontSize: '10px',
                marginBottom: 0,
              }}
            >
              AAA Auto Club Group is proud to serve Members in Colorado,
              Florida, Georgia, Illinois, Indiana, Iowa, Michigan, Minnesota,
              Puerto Rico, Nebraska, North Carolina, North Dakota, South
              Carolina, Tennessee and Wisconsin.
            </p>
          </form>
        </Modal>
      </ThemeProvider>
    </SearchProvider>
  );
};

export default Layout;
